module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.unread.length) ? _c('div', {
    staticClass: "notifications"
  }, _vm._l((_vm.unread), function(item, index) {
    return _c('Card', _vm._b({
      key: index,
      on: {
        "notificationViewed": _vm.postData
      }
    }, 'Card', item, false))
  }), 1) : _c('Warning', [_c('p', [_vm._v("Уведомлений нет.")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63e739ec","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/notification/views/unread/NotificationsUnread.vue
// module id = 0614a6394dbcb9dbdbde
// module chunks = 82